import { countsTowardTotals } from './accountMoney'
import type { Account } from './useAccounts'

export type AccountsMeta = {
  accountCount: number
  /** The oldest `last_synced_at` among accounts that count toward totals; null when every one is manual. */
  syncedAt: Date | null
}

/**
 * What a page header says about the household's accounts: a count and a date.
 * No money — so it stays available whatever becomes of the net-worth figure
 * (`useNetWorth`), which is the one owner-pending exception to the money freeze.
 */
export function accountsMeta(accounts: readonly Account[]): AccountsMeta {
  const synced = accounts
    .filter(countsTowardTotals)
    .map((a) => a.lastSyncedAt)
    .filter((d): d is Date => d !== null)
  return {
    accountCount: accounts.length,
    syncedAt: synced.length === 0 ? null : new Date(Math.min(...synced.map((d) => d.getTime()))),
  }
}
